const createObject = (key: string | number): object =>
  'number' === typeof key ? [] : 'string' === typeof key ? {} : undefined

const getObject = (obj: unknown, path: (string | number)[], create?: boolean): unknown => {
  const [key, ...rest] = path || []
  if (obj && rest.length > 0) {
    if (Array.isArray(obj) && 'number' === typeof key) {
      const thisObj = obj as unknown[]
      const nextObj = thisObj[key]
      return nextObj || (create && createObject(rest[0])) || undefined
    } else if ('object' === typeof obj && 'string' === typeof key) {
      const thisObj = obj as Record<string, unknown>
      const nextObj = thisObj[key]
      return nextObj || (create && createObject(rest[0])) || undefined
    }
  }
  return undefined
}

const updateObject = (obj: object, key: string | number, value: unknown): object => {
  if (obj) {
    if (Array.isArray(obj) && 'number' === typeof key) {
      const thisObj = obj as unknown[]
      const newObj = [...thisObj]
      newObj[key] = value
      return newObj
    } else if ('object' === typeof obj && 'string' === typeof key) {
      const thisObj = obj as Record<string, unknown>
      const newObj = { ...thisObj }
      newObj[key] = value
      return newObj
    }
  }
  return obj
}

export const setInImmutably = (obj: object, path: (string | number)[], value: unknown): object => {
  if (obj && path?.length > 0) {
    if (path.length === 1) {
      return updateObject(obj, path[0], value)
    } else {
      const nextObject = getObject(obj, path, true)
      if (nextObject) {
        const updatedNextObject = setInImmutably(nextObject as object, path.slice(1), value)
        return updateObject(obj, path[0], updatedNextObject)
      }
    }
  }
  return obj
}

export const deleteInImmutably = (obj: object, path: (string | number)[]): object => {
  if (obj && path?.length > 0) {
    if (path.length === 1) {
      if (Array.isArray(obj) && 'number' === typeof path[0]) {
        const thisObj = obj as unknown[]
        const newObj = [...thisObj]
        newObj.splice(path[0], 1)
        return newObj
      } else if ('object' === typeof obj && 'string' === typeof path[0]) {
        const thisObj = obj as Record<string, unknown>
        const newObj = { ...thisObj }
        delete newObj[path[0]]
        return newObj
      }
    } else {
      const nextObject = getObject(obj, path, false)
      if (nextObject) {
        const updatedNextObject = deleteInImmutably(nextObject as object, path.slice(1))
        return updateObject(obj, path[0], updatedNextObject)
      }
    }
  }
  return obj
}
